<app-header></app-header>
<section class="container-xxl">
  <!-- BREADCRUMB AREA - STARTS -->
  <div class="breadcrumb-area">
    <nav aria-label="breadcrumb mb-0">
      <ol class="breadcrumb">
        <li class="breadcrumb-item screen-reader"><a [attr.title]="language=='English'?'Home':'होम'" routerLink="/">{{ "Home" | translate }}</a></li>
        <li class="breadcrumb-item active screen-reader">{{'WhatsNewDetails'| translate}}</li>
      </ol>
    </nav>
    <!-- <app-plugin-breadcrumb [datacollection]="{data:P_data,'showEmpMen':showEmpMen,'emp_dtl':emp_dtl}" *ngIf="showBarComponent"></app-plugin-breadcrumb> -->
  </div>
  <!-- BREADCRUMB AREA - ENDS -->
  <div class="inner-page">
    <div class="inner-page-details">
      <div class="row">
        <div class="col-lg-12">
          <!-- INNER CONTENT - STARTS -->
          <div class="inner-page-sidedetails">
            <div class="row">
              <div class="col-lg-12">
                <div id="section-New"></div>
                <div class="inner-banner-image">
                  <div class="image-area">
                    <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                  </div>
                </div>
                <div class="details">
                  <!-- <div class="title d-flex justify-content-between">
                                     
                                        <h3> Whats New Details</h3>
                                      <a  (click)="archiveDetails()"  class="btn btn-sm btn-outline-success"><i class="bi bi-archive me-2"></i>Archive Whats New Details</a>
                                         </div> -->

                  <div class="title d-flex justify-content-between">
                    <div *ngIf="arcType; else other_content">
                      <h2 class="screen-reader">{{ "ArchiveWhatsNews" | translate }}</h2>
                    </div>
                    <ng-template #other_content>
                      <h2 class="screen-reader">{{'WhatsNewDetails'| translate}}</h2>
                    </ng-template>

                    <div *ngIf="arcType; else elseBlock">
                      <!-- Content to display when condition is true -->
                      <a href="javascript:void(0);"  (click)="goToPage('whatsnewdetails')" class="btn btn-sm btn-outline-success screen-reader"><i
                          class="bi bi-archive me-2"></i>{{'WhatsNewDetails'| translate}}</a>
                    </div>

                    <ng-template #elseBlock>
                      <!-- Content to display when condition is false -->
                      <a (click)="archiveDetails()" class="btn btn-sm btn-outline-success screen-reader"><i
                          class="bi bi-archive me-2"></i>{{ "ArchiveWhatsNews" | translate }}</a>
                    </ng-template>

                  </div>




                  <!-- press release section area -->
                  <div>
                    <div class="description">
                      <div class="whatsnew">
                        <div class="row">
                          <div class="col-lg-12">
                            <div>
                              <div class="d-flex justify-content-start flex-wrap whatsnew-box-area"
                                *ngFor="let item of whatsnewDetails ; let i=index">
                                <div class="whatsnew-count">
                                  <div class="count-box d-flex justify-content-center align-items-center screen-reader">
                                    <h2>{{i+1}}</h2>
                                  </div>
                                </div>
                                <div [ngSwitch]="item.VCHTYPE">
                                  <div class="whatsnew-details" *ngSwitchCase="3">
                                    <div class="whatsnew-txt font-adjust">
                                      <a class="screen-reader" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                                        (click)="viewDetails(item.NewsId, 'news')">{{htmldecode(item.NewsTitle)}}</a>
                                    </div>
                                    <p [innerHtml]="htmldecode(item.Newsdesc)" class="screen-reader font-adjust"></p>
                                    <div class="note-dates font-adjust d-sm-flex align-items-center">
                                      <div class="d-flex align-items-center flex-wrap flex-wrap">
                                        <div class="opening-date">
                                          <strong class="d-block text-green">
                                            <span class="me-2 screen-reader"> <i class="bi bi-calendar3 me-1"></i>

                                              {{ item.NewsPub | date:'dd-MM-YYYY' }}
                                            </span>
                                          </strong>
                                          <div class="text-muted screen-reader">{{ "PublishDate" | translate }}</div>
                                        </div>
                                      </div>
                                      <!-- <div class="opening-date" *ngIf="checkFileExists(item)"  >
                                                                                <strong class="d-block">
                                                                                  <a target="_blank" [href]="backend_url + 'storage/app/uploads/' + item.NewDoc" title="Download PDF" class="text-green">
                                                                                    <span class="me-2"> <i class="bi bi-download me-1"></i> Download 
                                                                                        ({{ item.uploadDocument_details.fileSize }}) 
                                                                                    </span>
                                                                                  </a>
                                                                                </strong>
                                                                                <span class="labels text-muted"></span>
                                                                              </div> -->
                                    </div>
                                  </div>

                                  <div class="whatsnew-details" *ngSwitchCase="4">
                                    <div class="whatsnew-txt font-adjust">
                                      <a class="screen-reader" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                                        (click)="viewDetails(item.PressId, 'pressreleasedetails')">{{htmldecode(item.PressTitle)}}</a>
                                    </div>

                                    <p class="screen-reader font-adjust" [innerHtml]="htmldecode(item.pressDesc)"></p>
                                    <div class="note-dates font-adjust d-sm-flex align-items-center">
                                      <div class="d-flex align-items-center flex-wrap flex-wrap">
                                        <div class="opening-date">
                                          <strong class="d-block text-green">
                                            <span class="me-2 screen-reader"> <i class="bi bi-calendar3 me-1"></i>

                                              {{ item.pressPub | date:'dd-MM-YYYY' }}
                                            </span>
                                          </strong>
                                          <div class="text-muted screen-reader">Date of Publish</div>
                                        </div>
                                      </div>
                                      <!-- <div class="opening-date" >
                                                                                <strong class="d-block">
                                                                                  <a target="_blank" [href]="backend_url + 'storage/app/uploads/' + item.pressDoc" title="Download PDF" class="text-green">
                                                                                    <span class="me-2"> <i class="bi bi-download me-1"></i> Download 
                                                                                        ({{ item.uploadDocument_details.fileSize }})
                                                                                    </span>
                                                                                  </a>
                                                                                </strong>
                                                                                <span class="labels text-muted"></span>
                                                                              </div> -->
                                    </div>
                                  </div>
                                  <div class="whatsnew-details" *ngSwitchCase="6">
                                    <div class="whatsnew-txt font-adjust">
                                      <a class="screen-reader" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                                        (click)="viewDetails(item.CirId, 'circulardetails')">{{htmldecode(item.CirTitle)}}</a>
                                    </div>
                                    <p class="screen-reader font-adjust" [innerHtml]="htmldecode(item.CirDesc)"></p>
                                    <div class="note-dates font-adjust d-sm-flex align-items-center">
                                      <div class="d-flex align-items-center flex-wrap flex-wrap">
                                        <div class="opening-date">
                                          <strong class="d-block text-green">
                                            <span class="me-2 screen-reader"> <i class="bi bi-calendar3 me-1"></i>

                                              {{ item.CirPub | date:'dd-MM-YYYY' }}
                                            </span>
                                          </strong>
                                          <div class="text-muted screen-reader">Date of Publish</div>
                                        </div>
                                      </div>
                                      <!-- <div class="opening-date">
                                                                                <strong class="d-block">
                                                                                  <a target="_blank" [href]="backend_url + 'storage/app/uploads/' + item.CirDoc" title="Download PDF" class="text-green">
                                                                                    <span class="me-2"> <i class="bi bi-download me-1"></i> Download
                                                                                         ({{ item.uploadDocument_details.fileSize }})
                                                                                        </span>
                                                                                  </a>
                                                                                </strong>
                                                                                <span class="labels text-muted"></span>
                                                                              </div> -->
                                    </div>
                                  </div>
                                  <div class="whatsnew-details" *ngSwitchCase="2">
                                    <div class="whatsnew-txt font-adjust">
                                      <a class="screen-reader" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                                        (click)="viewDetails(item.tenderId, 'tender-details')">{{htmldecode(item.TenderTitle)}}</a>
                                    </div>
                                    <p class="screen-reader font-adjust" [innerHtml]="htmldecode(item.TenderDesc)"></p>
                                    <div class="note-dates font-adjust d-sm-flex align-items-center">
                                      <div class="d-flex align-items-center flex-wrap flex-wrap">
                                        <div class="opening-date">
                                          <strong class="d-block text-green">
                                            <span class="me-2 screen-reader"> <i class="bi bi-calendar3 me-1"></i>

                                              {{ item.TenderPub | date:'dd-MM-YYYY' }}
                                            </span>
                                          </strong>
                                          <div class="text-muted screen-reader">Date of Publish</div>
                                        </div>
                                      </div>
                                      <!-- <div class="opening-date" >
                                                                                <strong class="d-block">
                                                                                  <a target="_blank" [href]="backend_url + 'storage/app/uploads/' + item.CirDoc" title="Download PDF" class="text-green">
                                                                                    <span class="me-2"> <i class="bi bi-download me-1"></i> Download 
                                                                                        ({{ item.uploadDocument_details.fileSize }})
                                                                                    </span>
                                                                                  </a>
                                                                                </strong>
                                                                                <span class="labels text-muted"></span>
                                                                              </div> -->
                                    </div>
                                  </div>
                                  <div class="whatsnew-details" *ngSwitchCase="7">
                                    <div class="whatsnew-txt font-adjust">
                                      <a class="screen-reader" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                                        (click)="viewDetails(item.AwrdId, 'awarddetails')">{{htmldecode(item.AwrdTitle)}}</a>
                                    </div>
                                    <p class="screen-reader font-adjust" [innerHtml]="htmldecode(item.AwrdDesc)"></p>
                                    <div class="note-dates font-adjust d-sm-flex align-items-center">
                                      <div class="d-flex align-items-center flex-wrap flex-wrap">
                                        <!-- <div class="opening-date">
                                                                                  <strong class="d-block text-green">
                                                                                    <span class="me-2"> <i class="bi bi-calendar3 me-1"></i>
                                                                                     
                                                                                      {{ item.TenderPub | date:'dd-MM-YYYY' }}
                                                                                    </span>
                                                                                  </strong>
                                                                                  <div class="text-muted">Date of Publish</div>
                                                                                </div> -->
                                      </div>
                                      <!-- <div class="opening-date" *ngIf="checkFileExists(item)">
                                                                                <strong class="d-block">
                                                                                  <a target="_blank" [href]="backend_url + 'storage/app/uploads/' + item.CirDoc" title="Download PDF" class="text-green">
                                                                                    <span class="me-2"> <i class="bi bi-download me-1"></i> Download ({{ item.uploadDocument_details.fileSize }})</span>
                                                                                  </a>
                                                                                </strong>
                                                                                <span class="labels text-muted"></span>
                                                                              </div> -->
                                    </div>
                                  </div>
                                  <div class="whatsnew-details" *ngSwitchCase="8">
                                    <div class="whatsnew-txt font-adjust">
                                      <!-- <a (click)="viewDetails(item.id, 'tender-details')">{{htmldecode(item.TenderTitle)}}</a> -->
                                      <a class="screen-reader" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'"
                                        (click)='goToExtLink(item.RecUrl)'>{{htmldecode(item.Rectitle)}}</a>
                                    </div>
                                    <!-- <p [innerHtml]="htmldecode(item.RecDoc)"></p> -->
                                    <div class="note-dates font-adjust d-sm-flex align-items-center">
                                      <div class="d-flex align-items-center flex-wrap flex-wrap">
                                        <div class="opening-date">
                                          <strong class="d-block text-green">
                                            <span class="me-2 screen-reader"> <i class="bi bi-calendar3 me-1"></i>

                                              {{ item.RecPub | date:'dd-MM-YYYY' }}
                                            </span>
                                          </strong>
                                          <div class="text-muted screen-reader">Date of Publish</div>
                                        </div>
                                      </div>
                                      <!-- <div class="opening-date" >
                                                                                <strong class="d-block">
                                                                                  <a target="_blank" [href]="backend_url + 'storage/app/uploads/' + item.RecDoc" title="Download PDF" class="text-green">
                                                                                    <span class="me-2"> <i class="bi bi-download me-1"></i> Download 
                                                                                        ({{ item.uploadDocument_details.fileSize }})
                                                                                    </span>
                                                                                  </a>
                                                                                </strong>
                                                                                <span class="labels text-muted"></span>
                                                                              </div> -->
                                    </div>
                                  </div>



                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <!-- press release section area -->
                    <div class="my-4">

                      <!-- <pagination-controls class="text-center" (pageChange)="pageChanged($event)" *ngIf="totalRecords > 10"></pagination-controls> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- INNER CONTENT - ENDS -->

</section>

<app-clients></app-clients>

<app-footer></app-footer>